import React from 'react';
import { Container, Text } from '@chakra-ui/react';

import { PageHeader } from 'shared-components';

import BackButton from '../../atoms/BackButton';
import PrevNextButtons from '../../atoms/PrevNextButtons';

interface IProps {
  children: React.ReactNode;
  currentStep?: number;
  steps?: number;
  complete?: boolean;
  section?: string;
  title?: string;
  subtitle?: string;
  hideProgress?: boolean;
  onSkip?: () => void;
  onPrevious?: () => void;
  onNext: () => void;
  onBackToTaskList?: () => void;
}

const QuestionPage: React.FC<IProps> = props => {
  const {
    children,
    complete,
    section,
    title,
    subtitle,
    // onSkip,
    onPrevious,
    onNext,
    onBackToTaskList
  } = props;

  return (
    <>
      <Container my={6}>
        {onBackToTaskList ? <BackButton onBackToTaskList={onBackToTaskList} /> : null}

        <PageHeader>{title || section}</PageHeader>

        {subtitle ? <Text>{subtitle}</Text> : null}

        {children}

        <PrevNextButtons onNext={onNext} onPrevious={onPrevious} complete={complete} nextLabel="Continue" />
      </Container>
    </>
  );
};

export default QuestionPage;
